import { Nullable } from 'utils/types';
import { StepIndex, StepState, ModalType } from './context';

export enum types {
  wNext = 'wizard/next',
  wPrev = 'wizard/prev',
  wGoToStep = 'wizard/goToStep',
  wSaveStepState = 'wizard/saveStepState',
  wPatchStepState = 'wizard/patchStepState',
  wSetStepsCount = 'wizard/setStepsCount',
  wOpenModal = 'wizard/openModal',
  wCloseModal = 'wizard/closeModal',
  wSetFlowCompleted = 'wizard/setFlowCompleted',
}

interface NextAction {
  type: typeof types.wNext;
}
const next = (): NextAction => ({
  type: types.wNext,
});

interface PrevAction {
  type: typeof types.wPrev;
}
const prev = (): PrevAction => ({
  type: types.wPrev,
});

interface GoToStepAction {
  type: types.wGoToStep;
  payload: number;
}
const goToStep = (payload: number): GoToStepAction => ({
  type: types.wGoToStep,
  payload,
});

interface SaveStepAction<T = StepState, K = StepIndex> {
  type: types.wSaveStepState;
  payload: { stepState: Nullable<T>; step: K };
}
const saveStepState = <TState, TKey extends keyof TState>(
  stepState: Nullable<TState[TKey]>,
  step: TKey
): SaveStepAction<TState[TKey], TKey> => ({
  type: types.wSaveStepState,
  payload: { stepState, step },
});

interface PatchStepStateAction<T = StepState, K = StepIndex> {
  type: types.wPatchStepState;
  payload: { stepState: T; step: K };
}
const patchStepState = <TState, TKey extends keyof TState>(
  stepState: Partial<TState[TKey]>,
  step: TKey
): PatchStepStateAction<Partial<TState[TKey]>, TKey> => ({
  type: types.wPatchStepState,
  payload: { stepState, step },
});

interface SetStepCountAction {
  type: typeof types.wSetStepsCount;
  payload: number;
}
const setStepsCount = (payload: number): SetStepCountAction => ({
  type: types.wSetStepsCount,
  payload,
});

interface OpenModalAction {
  type: typeof types.wOpenModal;
  payload: { type: ModalType; nextStep?: number };
}
const openModal = (type: ModalType, nextStep?: number): OpenModalAction => ({
  type: types.wOpenModal,
  payload: { type, nextStep },
});

interface CloseModalAction {
  type: typeof types.wCloseModal;
}
const closeModal = (): CloseModalAction => ({
  type: types.wCloseModal,
});

interface SetFlowCompleted {
  type: typeof types.wSetFlowCompleted;
  payload: boolean;
}
const setFlowCompleted = (payload: boolean): SetFlowCompleted => ({
  type: types.wSetFlowCompleted,
  payload,
});

export type WizardActions =
  | NextAction
  | PrevAction
  | GoToStepAction
  | SaveStepAction
  | PatchStepStateAction
  | SetStepCountAction
  | OpenModalAction
  | CloseModalAction
  | SetFlowCompleted;

export const actions = {
  next,
  prev,
  goToStep,
  saveStepState,
  patchStepState,
  setStepsCount,
  openModal,
  closeModal,
  setFlowCompleted,
};
